import { render } from "./productUpdate.vue?vue&type=template&id=4814ceb2"
import script from "./productUpdate.vue?vue&type=script&lang=js"
export * from "./productUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__